import { render, staticRenderFns } from "./Armory.vue?vue&type=template&id=3d231488&scoped=true&"
import script from "./Armory.vue?vue&type=script&lang=js&"
export * from "./Armory.vue?vue&type=script&lang=js&"
import style0 from "./Armory.vue?vue&type=style&index=0&id=3d231488&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d231488",
  null
  
)

export default component.exports